import Immutable from 'immutable';

export default (state, action, cb) => {
  const error   = action.error;
  const meta    = action.meta || {};
  const payload = action.payload;

  return state.withMutations((map) => {
    map.delete('error');
    map.delete('status');

    map.set('loading', meta.loading || false);

    if (error) {
      map.set('error', Immutable.fromJS(payload));
      map.set('status', 'error');
    } else if (typeof payload !== 'undefined') {
      map.set('status', 'success');

      if (cb) {
        cb(map, action);
      } else {
        map.set('data', Immutable.fromJS(payload));
      }
    }
  });
};



// WEBPACK FOOTER //
// ./app/lib/httpReducer.js